/**
 * Préremplissage de « Créer une carte » depuis une carte « à créer » d'un pack
 * (lot F, migration 0289) : `/tutor/cards/new?title=&level=&subject=&topic=`.
 * PUR, testé. Le texte source permet de cliquer directement « Générer la carte ».
 */

import { SCHOOL_LEVELS, SUBJECTS } from '@jeraisonne/db';
import type { CardInput } from './api';

export interface CardPrefill {
  title?: string;
  level?: string;
  subject?: string;
  topic?: string;
}

export function prefilledCardInput(prefill: CardPrefill, empty: CardInput): CardInput {
  if (!prefill.title && !prefill.level && !prefill.subject && !prefill.topic) return empty;
  const level = SCHOOL_LEVELS.some((l) => l.value === prefill.level) ? prefill.level! : null;
  const subject = SUBJECTS.some((s) => s.value === prefill.subject) ? prefill.subject! : null;
  const levelLabel = SCHOOL_LEVELS.find((l) => l.value === level)?.label;
  const source = [
    prefill.title ? `SKILLCARD : ${prefill.title}` : null,
    prefill.topic ? `Thème : ${prefill.topic}` : null,
    levelLabel ? `Niveau : ${levelLabel}` : null,
  ]
    .filter(Boolean)
    .join('\n');
  return {
    ...empty,
    title: prefill.title?.slice(0, 120) ?? empty.title,
    subject: subject ?? empty.subject,
    levels: level ? [level] : empty.levels,
    topic: prefill.topic?.slice(0, 120) ?? empty.topic,
    source_text: source || empty.source_text,
  };
}
